/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type DailyOrderCheckType =
  typeof DailyOrderCheckType[keyof typeof DailyOrderCheckType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DailyOrderCheckType = {
  PLATFORM_PAYMENT_DUE_RAISED_CHECK: 'PLATFORM_PAYMENT_DUE_RAISED_CHECK',
  PLATFORM_PAYMENT_RECEIVED_CHECK: 'PLATFORM_PAYMENT_RECEIVED_CHECK',
} as const;
